import Mutations from '../../odata/mutations';

export default { ...new Mutations('transactionModuleTask'), ...new Mutations('transactionModuleTasks') };
